/**
 * FloorBadge — Sticky floor price indicator.
 * Visible when hours > 0 and activeStep >= 2.
 * Gradient fade background for seamless scroll integration.
 */

import { T } from '@/styles/tokens';
import { AnimatedDollar } from './AnimatedDollar';

interface FloorBadgeProps {
  floorCents: number;
  visible: boolean;
}

export function FloorBadge({ floorCents, visible }: FloorBadgeProps) {
  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        display: 'flex',
        justifyContent: 'center',
        padding: '8px 0 4px',
        background: `linear-gradient(${T.cream}, ${T.cream}ee, transparent)`,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(-12px)',
        transition: `all 380ms ${T.easeOut}`,
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 14px',
          borderRadius: 20,
          background: T.white,
          border: `1px solid ${T.border}`,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}
      >
        <div
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: T.primary,
          }}
        />
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: T.charcoal400,
            fontFamily: T.fontFamily,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
          }}
        >
          Your Minimum
        </span>
        <AnimatedDollar value={floorCents} size={16} color={T.text} duration={400} />
      </div>
    </div>
  );
}
